import styles from "./ComponentSection.module.scss";

export default function ComponentSection({ children }: { children: React.ReactNode }) {
  return <div className={styles.componentSection}>{children}</div>;
}
